var Curriculog = Curriculog || {};

Curriculog.EntityFilter = (function ($, _, Backbone, EntityFilter) {

	EntityFilter = Curriculog.DropdownFilterView.extend({
		events: {
			'change': 'entityChanged'
		},

		get: function() {
			var that = this,
			    value = this.getSelectedValue(),
			    xhr1 = app.entities.fetch(),
			    xhr2 = this.collection.fetch();

			return $.when(xhr1, xhr2).done(function() {
				that.buildDropdown(app, value);
			});
		},

		buildDropdown: function (app, value) {
			var attributes = {};

			this.getDropdownAttributes(attributes);

			attributes.name = 'parents';

			var dropdown = new Curriculog.HierarchyDropdownView({
				collection: this.collection,
				entities: app.entities,
				ineligible: [],
				id: this.id,
				attributes: attributes,
				access: this.params.domParams.get('level'),
				noAvailableOptionsMessage: this.noAvailableOptionsMessage,
				firstOption: this.firstOption,
				selectedValue: (isNaN(value) ? value : parseInt(value)),
			});

			this.replaceDropdownDomElement(dropdown, value);
		},

        replaceDropdownDomElement: function (view, value) {
						// allow screen reader to focus on element to replace old empty element
						view.$el.attr('tabindex', 0);

            // Destroy the old empty element and replace it with the Backbone built select with options dynamically populated
            this.$el.selectWoo('destroy').replaceWith(view.$el);

            // Set the new element as the Backbone View element
            this.setElement(view.$el);

            // Apply the select2 plugin to the new element
            this.$el.selectWoo({
                theme: 'curriculog'
            });
						var label = this.$el.next().find('.select2-selection--single').attr('aria-labelledby');
						this.$el.next().find('.select2-selection--single').attr('aria-labelledby', this.$el.attr('id') + '-label' + ' ' + label );

            if (value) {
                // We want to trigger the select change event instead of just the select2 change event
                // when the DOM loads with values stored in localStorage, so that we can also trigger
                // the 'entityChanged' method as well
                this.$el.trigger('change');
            }
        },

		entityChanged: function() {
			// Trigger an event when the select value has changed so the 'includeEntityChildren' filter
			// can be updated if need be (checkbox checked or not)

			var options = {
				loading: false,
				value: this.getNewSelectedValue(),
				hasChildren: this.$el.find('option:selected').data('children'),
			};

			Backbone.trigger('entity:change', options);
		},
	});

	return EntityFilter;

})($, _, Backbone, Curriculog.EntityFilter || {});
